import { useEffect, useState } from "react";
import { usePostHog } from "posthog-js/react";

/**
 * Variant of a PostHog experiment flag, available synchronously once feature
 * flags have loaded. When `skipExposure` is true, evaluating the flag emits
 * no `$feature_flag_called` exposure event.
 */
export function useExperimentVariant(
  flag: string,
  skipExposure: boolean,
): string | boolean | undefined {
  const posthog = usePostHog();
  const [variant, setVariant] = useState<string | boolean | undefined>(() =>
    posthog?.getFeatureFlag(flag, { send_event: false }),
  );

  useEffect(() => {
    if (!posthog) return;
    return posthog.onFeatureFlags(() => {
      setVariant(posthog.getFeatureFlag(flag, { send_event: !skipExposure }));
    });
  }, [posthog, flag, skipExposure]);

  return variant;
}
